import { useSyncExternalStore } from 'react';
import {
  getRideMemberViewMode,
  isCompactRideViewMode,
  RideMemberViewMode,
  setRideMemberViewMode,
  subscribeRideMemberViewMode,
} from '@component/Ride/helper';

export const useRideMemberViewMode = ({
  forRide = true,
}: {
  forRide?: boolean;
}): {
  viewMode: RideMemberViewMode;
  setViewMode: (mode: RideMemberViewMode) => void;
  isCompactRideView: boolean;
} => {
  const viewMode = useSyncExternalStore(
    subscribeRideMemberViewMode,
    getRideMemberViewMode,
    (): RideMemberViewMode => 'DETAILED'
  );

  return {
    viewMode,
    setViewMode: setRideMemberViewMode,
    isCompactRideView: isCompactRideViewMode(forRide, viewMode),
  };
};
